import type { Notification } from '../interfaces/INotificationsApi.js';

/**
 * What `next` holds that `previous` did not: the notifications not listed
 * before, and those that grew — for chat, more unread than before. This is
 * what a sound, a ring or a peek answers to. It is read off the list, not
 * off a signal: a signal only says "ask again", and a read, or a message of
 * one's own, changes the list without adding to it.
 *
 * A new kind brings its own sense of "grew" here, beside chat's.
 */
export function newArrivals(previous: readonly Notification[], next: readonly Notification[]): Notification[] {
  const before = new Map(previous.map((n) => [n.id, n]));
  return next.filter((n) => {
    const was = before.get(n.id);
    if (!was) return true;
    if (n.unreadCount > was.unreadCount || (n.hasMore && !was.hasMore)) return true;
    // Past the cap the count cannot move; a later message shows only in the time.
    return was.hasMore && n.at > was.at;
  });
}
